import {
    Box,
    Button,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ContentIdeator() {
    const navigate = useNavigate();

    return (
        <Container style={{ padding: 0, width: "100%" }}>
            <Box className="voice-cloning-list-container">
                <Typography variant="featureAccent" gutterBottom>
                    Content Ideators
                </Typography>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                    sx={{ width: "100%", justifyContent: "flex-end" }}
                >
                    {/* <SearchInput
                        onSearch={handleSearch}
                        placeHolder="Sound..."
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        sx={{ width: "70vw" }}
                    /> */}

                    <Button
                        variant="contained"
                        size="large"
                        onClick={() => navigate("create")}
                    >
                        Create New
                    </Button>
                </Box>
            </Box>
            <Paper className="table-paper">
                <TableContainer className="table-container">
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-header-cell">
                                    Name
                                </TableCell>
                                <TableCell className="table-header-cell">
                                    Created At
                                </TableCell>
                                <TableCell className="table-header-cell">
                                    Created By
                                </TableCell>
                                <TableCell className="table-header-cell">
                                    Status
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow
                                sx={{
                                    userSelect: "none",
                                    "&:hover": {
                                        cursor: "pointer",
                                        backgroundColor: "#f9f9f9",
                                    },
                                }}
                                onClick={() => navigate("kavya")}
                            >
                                <TableCell className="table-cell">
                                    Kavya Mehra
                                </TableCell>
                                <TableCell className="table-cell">
                                    2025-02-28 12:00 PM
                                </TableCell>
                                <TableCell className="table-cell">
                                    Shivam Dewangan
                                </TableCell>
                                <TableCell
                                    className="table-cell"
                                    sx={{
                                        color: "success.main",
                                        fontWeight: 500,
                                    }}
                                >
                                    READY
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    count={1}
                    page={0}
                    rowsPerPage={10}
                />
            </Paper>
        </Container>
    );
}
